module.exports = __webpack_public_path__ + "img/nacd_2024_sponsor_logo.d500fcc4.svg";